import { FCX, getScaledPixels, useWindowSizeDebounced } from "@datassential/platform-ui-lib";
import TableRow from "@components/Table/TableRow";
import React, { useMemo, useRef } from "react";
import TableHead from "@components/Table/TableHead";
import { FixedSizeList } from "react-window";
import TableRowLoading from "@components/Table/TableRowLoading";
import WindowScroller from "@components/WindowScroller";
import cn from "classnames";

const WindowScrollerTable: FCX<{
    scrollerKey?: any;
    headHeight?: number;
    rowHeight?: number;
    rowsCount: number;
    isLoading?: boolean;
    showFallback?: boolean;
}> = ({
    scrollerKey,
    rowsCount,
    isLoading,
    headHeight = 38,
    rowHeight = 38,
    showFallback,
    children,
    className,
}) => {
    const [wWidth, wHeight] = useWindowSizeDebounced();
    const listRef = useRef<HTMLDivElement>(null);

    const itemsCount = useMemo(() => {
        if (!isLoading) return rowsCount;
        return Math.max(30, rowsCount);
    }, [isLoading, rowsCount]);

    const defaultFallback = useMemo(
        () => {
            if (rowsCount === 0 && !isLoading && showFallback) {
                return (
                    <span className="Table__fallback">No matching items found</span>
                );
            }

            return null;
        },
        [rowsCount, isLoading, showFallback]
    );

    return (
        <div className={cn(
            "Table",
            className,
        )}>
            <TableHead height={headHeight} isWindowsScroller/>
            {defaultFallback}
            <WindowScroller scrollerKey={scrollerKey} scrollerRef={listRef}/>
            <FixedSizeList
                // @ts-ignore
                ref={listRef}
                itemSize={getScaledPixels(rowHeight, wWidth)}
                width="100%"
                height={wHeight}
                itemCount={itemsCount}
                className="window-scroller-override"
            >
                {({ index, style }) => (
                    (isLoading && rowsCount === 0) ? (
                        <TableRowLoading style={style}/>
                    ) : (
                        <TableRow style={style} index={index}/>
                    )
                )}
            </FixedSizeList>
            {children}
        </div>
    );
};

export default WindowScrollerTable;